<template>
  <div class="company">
    <div class="companyContainer">
      <div class="company-detail">
        <h1 class="company-top">
          {{ companyDetail.reCompanyName }}
        </h1>
        <div class="company-detail-subTitle">
          <span class="tag" v-if="companyDetail.industry">{{
            companyDetail.industry
          }}</span
          ><span class="tag" v-if="companyDetail.enterpriseNature">{{
            companyDetail.enterpriseNature
          }}</span
          ><span class="tag" v-if="companyDetail.enterpriseScale">{{
            companyDetail.enterpriseScale
          }}</span>
          <span class="tag" v-if="companyDetail.groupName">{{
            companyDetail.groupName
          }}</span>
        </div>
        <div
          class="company-detail-description company-detail-block"
          v-if="companyDetail.reCompanyInfo"
        >
          <h2>公司描述</h2>
          <pre class="textContent" v-html="companyDetail.reCompanyInfo"></pre>
        </div>
        <div class="company-list">
          <h2>招聘职位</h2>
          <ul class="content-list">
            <li
              class="recommend-job-item"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <a :href="'/jobDetail/' + item.jobId" target="_blank">
                <!-- <router-link :to="'/jobDetail/' + item.jobId"> -->
                <div class="job-top-container">
                  <div class="job-top">
                    <div class="job-name substring">{{ item.job }}</div>
                    <div class="wage substring">{{ item.startSalary }}</div>
                  </div>
                  <div class="job-bottom substring">
                    <span class="tag" v-if="item.workingPlace">{{
                      item.workingPlace
                    }}</span
                    ><span class="tag" v-if="item.educationName">{{
                      item.educationName
                    }}</span
                    ><span class="tag" v-if="item.serviceName">{{
                      item.serviceName
                    }}</span>
                  </div>
                </div>
                <!-- </router-link> -->
              </a>
              <div class="company-bottom">
                <div class="company-desc">
                  <a :href="'/companyDetail/' + item.companyId" target="_blank">
                    <!-- <router-link :to="'/companyDetail/' + item.companyId"> -->
                    <div class="company-name substring">
                      {{ item.companyName }}
                    </div>
                    <!-- </router-link> -->
                  </a>
                </div>
              </div>
            </li>
          </ul>
          <!-- 分页器 -->
          <div class="pagination-wrapper">
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryFilter.pageNum"
              :limit.sync="queryFilter.pageSize"
              @pagination="jobList"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCompany, getJobsList } from "@/api/index.js";
export default {
  name: "companyDetail",
  data() {
    return {
      companyDetail: {},
      dataList: [],
      // 总条数
      total: 0,
      queryFilter: {
        pageNum: 1,
        pageSize: 10,
        companyId: "",
      },
    };
  },
  created() {
    this.queryFilter.companyId = this.$route.params.id;
    this.getCompanyDetail();
    this.jobList();
  },
  methods: {
    //公司详情
    getCompanyDetail() {
      getCompany(this.queryFilter.companyId)
        .then((res) => {
          this.companyDetail = res.data;
        })
        .catch(() => {});
    },

    //岗位列表
    jobList() {
      const loading = this.$loading();
      getJobsList(this.queryFilter)
        .then((res) => {
          loading.close();
          this.dataList = res.data;
          this.total = res.total;
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.company {
  background-color: #f3f3f3;
  padding-bottom: 30px;
  .companyContainer {
    width: @main-width;
    margin: auto;
    padding-top: 50px;
    line-height: 2em;
    .company-detail {
      width: @main-width;
      padding: 40px;
      background: #fff;
      box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
      border-radius: 8px;
      .company-top {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
        text-align: left;
        width: 100%;
      }
      &-subTitle {
        font-size: @font-size-base;
        color: @primary-text-color;
        margin: 20px 0;
        .tag:not(:first-child):before {
          content: "|";
          margin: 0 4px;
        }
      }
      &-description {
        .textContent {
          white-space: pre-line;
        }
      }
      &-block {
        h2 {
          margin-bottom: 20px;
        }
        margin: 40px 0;
        .textContent {
          font-size: @font-size-base;
          color: @primary-text-color;
        }
      }
      .content-list {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        .recommend-job-item {
          background-color: #fafbfd;
          box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
          border-radius: 8px;
          -webkit-box-sizing: content-box;
          box-sizing: content-box;
          margin-bottom: 21px;
          padding: 13px 25px;
          width: @main-width;
        }

        .job-top-container {
          border-bottom: 1px dotted #666;
          line-height: 30px;
          padding-bottom: 10px;
          .job-top {
            -ms-flex-align: center;
            -ms-flex-pack: justify;
            align-items: center;
            display: -ms-flexbox;
            display: flex;
            justify-content: space-between;
            .job-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
              text-align: left;
              width: 80%;
            }
            .wage {
              color: #d9011e;
              font-size: 16px;
              text-align: right;
              width: 20%;
            }
          }
        }

        .substring {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
          text-align: left;
        }
        .tag {
          font-size: 14px;
        }
        .tag:not(:first-child):before {
          content: "|";
          margin: 0 4px;
        }
        .company-bottom {
          -ms-flex-align: center;
          align-items: center;
          display: -ms-flexbox;
          display: flex;
          margin-top: 5px;
          .company-logo-box {
            height: 50px;
            margin-right: 20px;
            margin-top: 10px;
            -o-object-fit: contain;
            object-fit: contain;
            width: 50px;
          }
          img {
            border-style: none;
            vertical-align: middle;
          }
          .company-desc .company-tag {
            margin-top: 10px;
            width: 303px;
          }
        }
      }
      .pagination-wrapper {
        text-align: center;
      }
    }
  }
}
</style>
